import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";

const ConfidentialCompModal = (props) => {
    const { handleConfirm, handleReject } = props;

    return (
        <Dialog open={props.confidentialCompModalOpen} maxWidth="xs" aria-labelledby="confirmation-dialog-title">
            <DialogContent>
                <Typography variant="body1">
                    <h4 className="modal-title">
                        There are <span style={{ color: "red", fontWeight: "bold" }}>Confidential</span> Comps selected
                        in this report. Are you sure you would like to continue?
                    </h4>
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="outline" onClick={() => handleReject()} color="primary">
                    No
                </Button>
                <Button variant="contained" onClick={() => handleConfirm()} color="primary">
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfidentialCompModal;
